import { TreeNode } from 'primeng/api';
import { FilterTypes, NumberOfEmployeesValidCriteria } from '../../../models/filterEnums.model';
import { FilterCriteria } from '../shared/filter-criteria.model';

export class NumberOfEmployeesCriteria extends FilterCriteria {
  public override title = 'Number of Employees';
  public override type: FilterTypes = FilterTypes.NumberOfEmployees;
  absoluteYears: TreeNode[] = null;
  relativeYears: TreeNode[] = null;
  criteriaToBeValid: NumberOfEmployeesValidCriteria = NumberOfEmployeesValidCriteria.AtLeastOne;
  minimumValue: number = null;
  maximumValue: number = null;
  isPassIfNa?: boolean = false;

  public override validate(): boolean {
    if ((!this.absoluteYears || this.absoluteYears.length < 1) && (!this.relativeYears || this.relativeYears.length < 1)) {
      // No data selected for absolute years or relative years
      return false;
    }
    if (this.minimumValue && isNaN(this.minimumValue)) {
      return false;
    }
    if (this.maximumValue && isNaN(this.maximumValue)) {
      return false;
    }
    if (!this.checkFalseExceptZero(this.minimumValue) && !this.checkFalseExceptZero(this.maximumValue)) {
      return false;
    }
    if (
      this.checkFalseExceptZero(this.maximumValue) &&
      this.checkFalseExceptZero(this.minimumValue) &&
      parseInt(this.minimumValue.toString(), 10) > parseInt(this.maximumValue.toString(), 10)
    ) {
      return false;
    }
    return true;
  }

  public override toString(): string {
    const s: string[] = [];
    if (this.absoluteYears && this.absoluteYears.length > 0) {
      s.push('Absolute Years: ' + this.absoluteYears.map((selection) => selection.label).join(', '));
    }
    if (this.relativeYears && this.relativeYears.length > 0) {
      s.push('Relative Years: ' + this.relativeYears.map((selection) => selection.label).join(', '));
    }
    if (this.criteriaToBeValid) {
      s.push('Criteria to be valid: ' + this.criteriaToBeValid);
    }
    if (this.minimumValue) {
      s.push('Minimum Value: ' + this.minimumValue);
    }
    if (this.maximumValue) {
      s.push('Maximum Value: ' + this.maximumValue);
    }
    return s.join(' | ');
  }

  checkFalseExceptZero(value): boolean {
    if (Array.isArray(value)) {
      return !!value.length;
    }
    return value === 0 || !!value;
  }
}
